<div class="dialog-container">

  <!-- Header -->
  <div class="dialog-header">
    <div class="dialog-header-left">
      <span class="dialog-title">Aprovar Itens do Contrato</span>
      @if (data?.codigoTg || data?.nomeCliente) {
        <span class="dialog-subtitle">{{ data.codigoTg || data.nomeCliente }}</span>
      }
    </div>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Toolbar -->
  <div class="toolbar">
    <mat-form-field appearance="outline" class="search-field input-tg">
      <mat-label>Pesquisar</mat-label>
      <input matInput [(ngModel)]="searchText" (ngModelChange)="applyFilter()" placeholder="Veículo, serviço, cidade..." />
    </mat-form-field>

    <div class="toolbar-actions">
      <button mat-button class="btn-tg"
        (click)="toggleSelectAll()"
        [disabled]="approving || pendingItems.length === 0"
        [matTooltip]="allPendingSelected ? 'Desmarcar todos' : 'Selecionar todos pendentes'">
        <mat-icon>{{ allPendingSelected ? 'indeterminate_check_box' : 'check_box_outline_blank' }}</mat-icon>
        {{ allPendingSelected ? 'Desmarcar Todos' : 'Selecionar Pendentes' }}
      </button>

      <button mat-button class="btn-tg btn-confirm"
        (click)="approveSelected()"
        [disabled]="approving || selectedIds.size === 0">
        <mat-icon>check_circle</mat-icon>
        Aprovar Selecionados ({{ selectedIds.size }})
      </button>

    </div>
  </div>

  @if (loading || approving) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <!-- Items list -->
  <div class="items-container">

    @if (!loading && filteredItems.length === 0) {
      <div class="empty-state">
        <mat-icon>inbox</mat-icon>
        <p>Nenhum item encontrado.</p>
      </div>
    }

    @for (item of filteredItems; track item.id) {
      <div class="item-card"
        [ngClass]="{
          'item-card-approved': item.temOs,
          'item-card-selected': !item.temOs && selectedIds.has(item.id)
        }">

        <div class="item-checkbox">
          <mat-checkbox
            [checked]="selectedIds.has(item.id)"
            [disabled]="item.temOs || approving"
            (change)="toggleItem(item)">
          </mat-checkbox>
        </div>

        <div class="item-body">
          <div class="item-row-top">
            <span class="item-veiculo">{{ item.tipoVeiculoDescricao || '-' }}</span>
            <span class="item-servico">{{ item.servicoDescricao || '-' }}</span>
            @if (item.temOs) {
              <span class="badge badge-approved">
                <mat-icon class="badge-icon">check_circle</mat-icon>
                OS Criada
              </span>
            } @else {
              <span class="badge badge-pending">Pendente</span>
            }
          </div>
          <div class="item-row-bottom">
            <span class="item-meta">
              <mat-icon class="meta-icon">route</mat-icon>
              {{ item.cidadeOrigem || '-' }} → {{ item.cidadeDestino || '-' }}
            </span>
            <span class="item-meta">
              <mat-icon class="meta-icon">calendar_today</mat-icon>
              {{ item.dataInicio || '-' }}
              @if (item.horaInicio) { · {{ item.horaInicio.substring(0, 5) }} }
            </span>
            <span class="item-meta">
              <mat-icon class="meta-icon">people</mat-icon>
              {{ item.quantidadePassageiro ?? '-' }} PAX
            </span>
          </div>
        </div>

        <div class="item-actions">
          <button class="btn-icon" [matTooltip]="'Visualizar informações'" (click)="viewItem(item)">
            <mat-icon>visibility</mat-icon>
          </button>
          @if (item.temOs) {
            <button class="btn-icon btn-icon-danger"
              [matTooltip]="'Cancelar OS'"
              [disabled]="isCanceling(item)"
              (click)="cancelServiceOrder(item)">
              <mat-icon>cancel</mat-icon>
            </button>
          }
        </div>

      </div>
    }

  </div>

  <!-- Footer -->
  <div class="dialog-footer">
    <span class="footer-info">
      {{ items.length }} item(s) total · {{ pendingItems.length }} pendente(s)
    </span>
    <button mat-button class="btn-tg-white" (click)="close()">Fechar</button>
  </div>

</div>
